import { render, staticRenderFns } from "./MmplEditMain.vue?vue&type=template&id=02c22824&scoped=true&"
import script from "./MmplEditMain.vue?vue&type=script&lang=js&"
export * from "./MmplEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MmplEditMain.vue?vue&type=style&index=0&id=02c22824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c22824",
  null
  
)

export default component.exports